import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { InputTextComponent } from "./molecules/input-text/input-text.component";
import { InputBaseComponent } from "./atoms/input-base/input-base.component";
import { InputPasswordComponent } from "./molecules/input-password/input-password.component";
import { InputOtpComponent } from "./molecules/input-otp/input-otp.component";
import { DateRangeFilterComponent } from "./molecules/date-range-filter/date-range-filter.component";
import { CoreUIIconsModule } from "../icons/core-ui-icons.module";
import { DropdownComponent } from "./molecules/dropdown/dropdown.component";
import { InputDateComponent } from "./molecules/input-date/input-date.component";
import { InputTextFormComponent } from "./atoms/input-text-form/input-text-form.component";
import { AutocompleteFormComponent } from "./atoms/input-autocomplete-form/input-autocomplete-form.component";
import { ChipsAutocompleteFormComponent } from "./atoms/chips-autocomplete-form/chips-autocomplete-form.component";
import { InputDateRangeComponent } from "./molecules/input-date-range/input-date-range.component";
import { InputTimeComponent } from "./molecules/input-time/input-time.component";
import { OverlayModule } from '@angular/cdk/overlay';
import { InactiveTimeDropdownComponent } from "./molecules/inactive-time-dropdown/inactive-time-dropdown.component";
import { CoreUiDirectivesModule } from "../directives/core-ui-directives.module";
import { FileUploadCardComponent } from "./molecules/file-upload-card/file-upload-card.component";
import { TextareaFormComponent } from "./atoms/textarea-form/textarea-form.component";
import { CompactSelectComponent } from "./molecules/compact-select/compact-select.component";
import { MessageComposerComponent } from "./molecules/message-composer/message-composer.component";
import { CoreUISwitchComponent } from "./atoms/switch/switch.component";
import { CoreUiCardsModule } from "../cards/core-ui-cards.module";
import { CoreUiButtonsModule } from "../buttons/core-ui-buttons.module";

@NgModule({
    declarations: [
        InputBaseComponent,
        InputTextComponent,
        InputPasswordComponent,
        InputOtpComponent,
        DateRangeFilterComponent,
        DropdownComponent,
        InputDateComponent,
        InputTextFormComponent,
        AutocompleteFormComponent,
        ChipsAutocompleteFormComponent,
        InputDateRangeComponent,
        InputTimeComponent,
        InactiveTimeDropdownComponent,
        FileUploadCardComponent,
        TextareaFormComponent,
        CompactSelectComponent,
        MessageComposerComponent,
        CoreUISwitchComponent
    ],
    imports: [
        CommonModule,
        CoreUIIconsModule,
        CoreUiDirectivesModule,
        CoreUiButtonsModule,
        CoreUiCardsModule,
        OverlayModule
    ],
    exports: [
        InputBaseComponent,
        InputTextComponent,
        InputPasswordComponent,
        InputOtpComponent,
        DateRangeFilterComponent,
        DropdownComponent,
        InputDateComponent,
        InputTextFormComponent,
        AutocompleteFormComponent,
        ChipsAutocompleteFormComponent,
        InputDateRangeComponent,
        InputTimeComponent,
        InactiveTimeDropdownComponent,
        FileUploadCardComponent,
        TextareaFormComponent,
        CompactSelectComponent,
        MessageComposerComponent,
        CoreUISwitchComponent
    ]
})
export class CoreUiInputsModule { }
